const getLegendUrl = (layer) => {
	return layer.url + 'version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&format=image/jpeg&layer=' + layer.layer
}
export { getLegendUrl }



// WEBPACK FOOTER //
// ./src/utils/mapUtils/LegendUtils.js